import { Input, Select } from "top-component-library";

// Shared between the Menu-only BOS and BOS Builder enable wizards: picks what the
// "Switch Location" link on the menu page says, or removes it entirely. Mirrors the
// legacy dialogs' own markup, which has no label on this select - only the preceding
// paragraph introduces it, and only the conditional custom-text input gets a label.
const SwitchTextField = ({ choice, text, onChoiceChange, onTextChange }) => (
  <div>
    <Select id="switch-text-choice" value={choice} onChange={onChoiceChange}>
      <Select.Option value="remove">Remove link</Select.Option>
      <Select.Option value="custom">Custom text</Select.Option>
      <Select.Option value="default">Set to default</Select.Option>
    </Select>
    {choice === "custom" && (
      <div>
        <label htmlFor="switch-text-input">
          <strong>&quot;Switch Location&quot;</strong> text
        </label>
        <Input id="switch-text-input" value={text} onChange={(e) => onTextChange(e.target.value)} />
      </div>
    )}
  </div>
);

export default SwitchTextField;
